import FitterReview from './fitter_review';
import PropTypes from 'prop-types';

const SHOW_ALL_REVIEWS = 0;

function getReviewsList(reviews, limitShownReviewsTo, fsName) {
    return reviews.map((review, index) => {
        if (limitShownReviewsTo === SHOW_ALL_REVIEWS || index < limitShownReviewsTo) {
            return <FitterReview data={review} key={index} fsName={fsName} />;
        }

        return null;
    });
}

function FitterReviewsList(props) {
    return (
        <div className="fsf-station__fitter-reviews">
            {getReviewsList(props.reviews, props.limitShownReviewsTo, props.fsName)}
        </div>
    );
}

FitterReviewsList.propTypes = {
    reviews: PropTypes.array.isRequired,
    fsName: PropTypes.string.isRequired,
    limitShownReviewsTo: PropTypes.number,
};

FitterReviewsList.defaultProps = {
    limitShownReviewsTo: 0,
};

export default FitterReviewsList;